/**
 * Simple pass-through for react-toastify toast
 * w/ some defaults for WS/HB
 */
import * as React from 'react';
import { ToastContainerProps, ToastContainer, toast, ToastContent } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';
import { ToastOptions } from 'react-toastify';
require('./style.scss');

interface OwnProps extends ToastContainerProps {
    showCloseButton?: boolean;
}

const defaultToastProps: ToastContainerProps = {
    className: 'HBToastContainer',
    hideProgressBar: true,
    newestOnTop: true,
    //draggable: false,
    //autoClose: false,
};

interface CloseProps {
    closeToast?: (e: React.SyntheticEvent<HTMLButtonElement>) => void;
}

class CloseButton extends React.Component<CloseProps> {
    render() {
        return (
            <button type='button' className='HBToastContainer--close-btn' onClick={this.props.closeToast}>
                <i className='icon-hb-nx-close-16' />
            </button>
        );
    }
}

export class HBToastContainer extends React.Component<OwnProps> {
    render() {
        const { showCloseButton } = this.props;

        let containerProps = {
            ...this.props,
            ...defaultToastProps,
        };

        if (showCloseButton) {
            containerProps.closeButton = <CloseButton />;
        }

        return <ToastContainer {...containerProps} />;
    }
}

const wrap = (content: ToastContent) => {
    return (
        <div className='HBToast--body-wrapper'>
            <div className='HBToast--content-wrapper'>{content}</div>
        </div>
    );
};

export const hbToast = (content: ToastContent, options?: ToastOptions) => {
    return toast(content, options);
};

export const hbToastSuccess = (content: ToastContent, options?: ToastOptions) => {
    return toast.success(wrap(content), options);
};

export const hbToastInfo = (content: ToastContent, options?: ToastOptions) => {
    return toast.info(wrap(content), options);
};

export const hbToastWarn = (content: ToastContent, options?: ToastOptions) => {
    return toast.warn(wrap(content), options);
};

export const hbToastError = (content: ToastContent, options?: ToastOptions) => {
    return toast.error(wrap(content), options);
};
